/**
 * O que cada papel alcança.
 *
 * Fonte única: o backend decide se responde e o frontend decide se mostra, e os
 * dois leem daqui. Duas listas separadas divergem — o menu passa a oferecer uma
 * tela que a API recusa, e o operador conclui que o sistema está quebrado.
 *
 * Três papéis fixos em vez de permissão por tela. A granularidade só se paga
 * quando há perfis que não cabem num punhado de grupos; aqui há exatamente três
 * pessoas diferentes: quem administra, quem atende e a TV.
 */
/** As áreas do sistema, no nível em que faz sentido conceder acesso. */
export const AREAS = [
    /** Atender: criar e acompanhar gerações. */
    "atendimento",
    /** Acervo: banco de imagens, capas e divulgações. */
    "acervo",
    /** Administração: vivências, instituições, participantes, custos, usuários, configurações. */
    "administracao",
    /** A projeção na TV. */
    "galeria",
];
const ACESSO = {
    admin: AREAS,
    // O cliente do SaaS opera como um operador — mas só sobre os próprios dados;
    // o recorte por dono é do backend, não desta tabela.
    cliente: ["atendimento", "acervo", "galeria"],
    operador: ["atendimento", "acervo", "galeria"],
    // A TV não atende ninguém e não configura nada: só projeta.
    kiosk: ["galeria"],
};
export function podeAcessar(papel, area) {
    return papel !== null && ACESSO[papel].includes(area);
}
/** Para onde mandar alguém que acabou de entrar. */
export function rotaInicial(papel) {
    return papel === "kiosk" ? "/galeria" : "/nova";
}
export const ROTULO_PAPEL = {
    admin: "Administrador",
    cliente: "Cliente",
    operador: "Operador",
    kiosk: "Quiosque",
};
export const DESCRICAO_PAPEL = {
    admin: "Acessa tudo, inclusive usuários e configurações.",
    cliente: "Dono de uma conta: atende, gerencia o próprio acervo e a própria galeria.",
    operador: "Atende, gerencia o acervo e abre a galeria.",
    kiosk: "Só abre a galeria na TV. Não vê atendimento nem administração.",
};
//# sourceMappingURL=permissoes.js.map